var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _g, _polygon23, _polygon24, _polyline, _g2, _g3, _g4, _g5, _polygon25, _polygon26, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path, _path2, _g14, _g15, _g16, _g17, _g18, _path3, _path4, _path5, _path6, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _path7, _path8, _path9, _path10, _polygon48, _polygon49, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _polyline2, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.99 176.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6e63fb;}.cls-2{fill:#5552e2;}.cls-3{isolation:isolate;}.cls-4{fill:#00576c;}.cls-5{fill:#0089aa;}.cls-6{fill:#2f2bb2;}.cls-7{fill:#009bbf;}.cls-8{fill:#005f74;}.cls-9{fill:#fff;}.cls-10{fill:#0091b3;}.cls-11{fill:#007e9b;}.cls-12{fill:#00738c;}.cls-13{fill:#006981;}.cls-14{fill:#00b0d7;}.cls-15{fill:#00a6cc;}.cls-16{fill:#009bbe;}.cls-17{fill:#3f3d55;}.cls-18{fill:#2424a3;}.cls-19{fill:#507396;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "130.38 66.55 128.9 67.41 127.08 68.46 123.02 70.81 121.2 71.86 117.14 74.22 115.32 75.27 111.27 77.62 109.44 78.67 105.38 81.03 103.56 82.08 99.5 84.43 97.68 85.49 93.62 87.84 91.8 88.9 87.74 91.25 85.92 92.3 81.86 94.66 80.04 95.7 75.98 98.06 74.16 99.11 70.1 101.47 68.28 102.51 64.22 104.87 62.4 105.93 58.34 108.28 56.52 109.33 52.46 111.69 50.64 112.74 46.59 115.09 44.76 116.14 40.7 118.5 38.88 119.55 34.83 121.9 33 122.95 28.94 125.31 27.12 126.36 23.07 128.71 21.23 129.77 17.18 132.12 15.37 133.18 10.04 136.26 9.37 114.54 7.55 69.59 12.61 66.86 14.43 65.8 18.48 63.45 20.31 62.39 24.36 60.04 26.19 58.99 30.24 56.64 32.07 55.58 36.12 53.23 37.95 52.17 42 49.83 43.84 48.77 47.89 46.42 49.7 45.36 53.76 43.01 55.59 41.96 59.66 39.6 61.47 38.55 65.53 36.2 67.36 35.15 71.42 32.79 73.23 31.75 77.3 29.39 79.12 28.33 83.17 25.99 84.99 24.93 89.05 22.57 90.88 21.52 94.93 19.17 96.76 18.12 100.82 15.76 102.64 14.71 106.69 12.36 108.52 11.31 112.58 8.95 114.39 7.91 118.45 5.55 120.28 4.49 124.34 2.14 126.15 1.09 127.2 0.84 130.38 66.55"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.18 132.12 15.37 133.18 12.61 66.86 14.43 65.8 17.18 132.12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.07 128.71 21.23 129.77 18.48 63.45 20.31 62.39 23.07 128.71"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.94 125.31 27.12 126.36 24.36 60.04 26.19 58.99 28.94 125.31"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34.83 121.9 33 122.95 30.24 56.64 32.07 55.58 34.83 121.9"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.7 118.5 38.88 119.55 36.12 53.23 37.95 52.17 40.7 118.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.59 115.09 44.76 116.14 42 49.83 43.84 48.77 46.59 115.09"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.46 111.69 50.64 112.74 47.89 46.42 49.7 45.36 52.46 111.69"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.34 108.28 56.52 109.33 53.76 43.01 55.59 41.96 58.34 108.28"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.22 104.87 62.4 105.93 59.66 39.6 61.47 38.55 64.22 104.87"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "70.1 101.47 68.28 102.51 65.53 36.2 67.36 35.15 70.1 101.47"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.98 98.06 74.16 99.11 71.42 32.79 73.23 31.75 75.98 98.06"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.86 94.66 80.04 95.7 77.3 29.39 79.12 28.33 81.86 94.66"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.74 91.25 85.92 92.3 83.17 25.99 84.99 24.93 87.74 91.25"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "93.62 87.84 91.8 88.9 89.05 22.57 90.88 21.52 93.62 87.84"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.5 84.43 97.68 85.49 94.93 19.17 96.76 18.12 99.5 84.43"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.38 81.03 103.56 82.08 100.82 15.76 102.64 14.71 105.38 81.03"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.27 77.62 109.44 78.67 106.69 12.36 108.52 11.31 111.27 77.62"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "117.14 74.22 115.32 75.27 112.58 8.95 114.39 7.91 117.14 74.22"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.02 70.81 121.2 71.86 118.45 5.55 120.28 4.49 123.02 70.81"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.9 67.41 127.08 68.46 124.34 2.14 126.15 1.09 128.9 67.41"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.34 7.15 172.47 33.35 129.52 58.85 127.34 7.15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "6.17 141.37 1.02 144.35 0.82 73.82 5.97 70.85 6.17 141.37"
  }))), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0.33 142.97 0.74 143.21 0.74 143.68 0.73 145.13 0.33 144.89 0.33 143.44 0.33 142.97"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.45 74.23 126.8 0.83 126.8 1.3 126.8 2.75 0.44 76.16 0.45 74.7 0.45 74.23"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "126.39 0.59 126.8 0.83 0.45 74.23"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.23 159.95 26.05 159.84 26.04 146.89 26.04 145.17 26.03 135.16 26.03 133.08 26.01 113.86 26.01 112.46 26 112.13 25.99 102.12 25.99 100.05 25.98 90.03 26.15 90.43 26.16 100.16 26.16 102.23 26.17 112.23 26.17 112.56 26.18 113.63 26.18 113.97 26.2 133.18 26.2 135.26 26.21 145.28 26.21 147 26.23 159.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.17 89.85 27.35 90.25 26.84 90.54 26.16 90.43 25.98 90.03 26.48 89.74 27.17 89.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.92 159.9 26.92 160.37 26.59 160.17 26.59 160.1 26.53 160.13 26.23 159.95 26.21 147 26.21 145.28 26.2 135.26 26.2 133.18 26.18 113.97 26.18 113.63 26.17 112.56 26.17 112.23 26.16 102.23 26.16 100.16 26.15 90.43 26.34 90.46 26.39 90.47 26.85 90.54 26.86 100.57 26.86 102.63 26.87 112.64 26.88 112.75 26.88 114.37 26.89 133.61 26.89 135.67 26.91 145.68 26.91 147.4 26.92 159.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.92 160.37 26.92 159.9 26.91 147.4 26.91 145.68 26.89 135.67 26.89 133.61 26.88 114.37 26.88 112.75 26.87 112.64 26.86 102.63 26.86 100.57 26.85 90.54 27.14 90.36 27.35 90.25 27.36 100.86 27.36 102.92 27.37 112.95 27.37 114.66 27.39 133.9 27.4 135.96 27.41 145.99 27.41 147.69 27.42 160.65 26.92 160.37"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.67 159.04 24.48 158.93 24.46 145.97 24.46 144.26 24.45 134.22 24.45 132.16 24.43 112.93 24.43 111.55 24.42 111.22 24.41 101.19 24.41 99.14 24.41 89.11 24.59 89.51 24.6 99.25 24.6 101.3 24.61 111.33 24.62 111.65 24.62 113.04 24.64 132.27 24.64 134.33 24.65 144.37 24.65 146.08 24.67 159.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.6 88.93 25.78 89.33 25.28 89.62 24.59 89.51 24.41 89.11 24.91 88.82 25.6 88.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.35 159.44 24.67 159.04 24.65 146.08 24.65 144.37 24.64 134.33 24.64 132.27 24.62 113.04 24.62 111.65 24.61 111.33 24.6 101.3 24.6 99.25 24.59 89.51 25.27 89.62 25.28 99.65 25.28 101.7 25.29 111.72 25.3 112.05 25.3 113.44 25.32 132.67 25.32 134.73 25.33 144.76 25.33 146.48 25.35 159.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.86 159.74 25.35 159.44 25.33 146.48 25.33 144.76 25.32 134.73 25.32 132.67 25.3 113.44 25.3 112.05 25.29 111.72 25.28 101.7 25.28 99.65 25.27 89.62 25.78 89.33 25.79 99.94 25.79 102 25.81 112.03 25.81 113.75 25.83 132.96 25.83 135.04 25.84 145.06 25.84 146.78 25.86 159.74"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "126.37 0.2 126.79 0.45 0.45 73.79 126.37 0.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "0.45 73.79 1.75 74.54 1.75 75.03 0.45 74.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "128.08 1.19 128.08 1.68 1.75 75.03 1.75 74.54 128.08 1.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "128.33 1.05 122.38 4.5 6.93 71.47 5.27 70.51 121.07 3.74 127.04 0.3 128.33 1.05"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "174.52 32.14 175.84 34.95 49.61 109.64 49.26 106.05 174.52 32.14"
  }))), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "52.38 173.24 52.79 173.47 52.79 173.94 52.78 175.4 52.38 175.16 52.38 173.71 52.38 173.24"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "52.79 173.47 179.15 100.07 179.15 100.54 179.14 101.99 52.78 175.4 52.79 173.94 52.79 173.47"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.13,131.39l-.35,70.15,5.16-3v0l0-6.32.24-63.73Zm.93,65.8A4.05,4.05,0,0,1,361.9,194c1-.59,1.85-.12,1.85,1.05a4.07,4.07,0,0,1-1.84,3.19C360.9,198.83,360.07,198.36,360.06,197.19Z",
    transform: "translate(-184.66 -96.63)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "58.73 171.88 52.7 176.02 52.58 175.95 52.97 141.49 53 138.93 53.02 135.07 53.19 104.82 53.26 104.78 58.53 101.78 58.73 171.88"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.39 104.19 53.39 105.08 3.74 76.22 0.28 73.34 3.74 75.35 53.39 104.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "58.37 101.32 53.39 104.19 3.74 75.39 0.24 73.36 0.28 73.34 0.59 73.16 5.27 70.51 58.37 101.32"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "179.6 30.83 173.55 34.04 122.38 4.5 121.07 3.74 127.04 0.3 128.33 1.05 179.6 30.83"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "52.7 176.01 49.16 174.08 48.95 102.49 52.6 104.61 52.7 176.01"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3.74 75.01 3.74 76.22 3.67 147.23 0.07 145.13 0.24 73.36 0.59 73.16 3.74 75.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3.86 146.77 3.06 147.23 2.85 75.76 3.66 75.29 3.86 146.77"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M362.12,199.19a.8.8,0,0,1-.34-.11l-1.18-.69a.92.92,0,0,0,.34.12Z",
    transform: "translate(-184.66 -96.63)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M364.64,197.08a4.34,4.34,0,0,1-.86,1.33l-1.18-.69a4.41,4.41,0,0,0,.86-1.33Z",
    transform: "translate(-184.66 -96.63)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364,192.22,358.84,195l0,6.57,5.14-3h0l.06-6.34Zm-2.06,6c-1,.58-1.84.11-1.85-1.06A4.05,4.05,0,0,1,361.9,194c1-.59,1.85-.12,1.85,1.05A4.07,4.07,0,0,1,361.91,198.25Z",
    transform: "translate(-184.66 -96.63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.75,195.06a4.07,4.07,0,0,1-1.84,3.19c-1,.58-1.84.11-1.85-1.06A4.05,4.05,0,0,1,361.9,194C362.92,193.42,363.75,193.89,363.75,195.06Z",
    transform: "translate(-184.66 -96.63)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241,269.86l-.19.08-1.18-.69.19-.07Z",
    transform: "translate(-184.66 -96.63)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.79,205.46l-.18.08-1.19-.69.19-.08Z",
    transform: "translate(-184.66 -96.63)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.62,201.49l1.18.69h0a1.48,1.48,0,0,1,0,.21l-1.18-.68c0-.08,0-.15,0-.22Z",
    transform: "translate(-184.66 -96.63)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M362.9,134.53l-.18.09-1.18-.68.17-.09Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M362.72,134.62l-.18.08-1.18-.69.18-.07Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M362.54,134.7l-.19.05-1.18-.68.19-.06Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M362.35,134.75l-.2,0L361,134.1l.2,0Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M362.15,134.78h-.23l-1.18-.69H361Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361.92,134.78a1,1,0,0,1-.34-.12L360.4,134a.92.92,0,0,0,.34.12Z",
    transform: "translate(-184.66 -96.63)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M364.44,132.66a4.34,4.34,0,0,1-.86,1.33l-1.18-.69a4.41,4.41,0,0,0,.86-1.33Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M363.58,134l-.26.24-1.18-.69a2.84,2.84,0,0,0,.26-.24Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M363.32,134.23l-.21.16-1.18-.68.21-.17Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M363.11,134.39a1.37,1.37,0,0,1-.2.13l-1.18-.69a2.12,2.12,0,0,0,.2-.12Z",
    transform: "translate(-184.66 -96.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M362.91,134.52h0l-1.19-.68,0,0Z",
    transform: "translate(-184.66 -96.63)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.26,127.46l-5.08,2.89.06,7.08,4.94-2.89Zm-.62,3.14a4.06,4.06,0,0,1-1.83,3.19c-1,.59-1.85.11-1.85-1.06a4,4,0,0,1,1.83-3.18C362.81,129,363.64,129.43,363.64,130.6Z",
    transform: "translate(-184.66 -96.63)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.26,124l-5.07,2.92,6,3.49,5.07-2.93Zm-.69,2.53a4,4,0,0,1,3.63,0,1.11,1.11,0,0,1,0,2.1,4,4,0,0,1-3.62,0A1.11,1.11,0,0,1,357.57,126.51Z",
    transform: "translate(-184.66 -96.63)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.19,96.63l-5,3.08,5.3,2.93,5.05-2.91Z",
    transform: "translate(-184.66 -96.63)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.79,133",
    transform: "translate(-184.66 -96.63)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "174.18 102.95 172.43 104.05 170.69 105.06 166.81 107.31 165.06 108.32 161.19 110.58 159.44 111.59 155.57 113.84 153.82 114.85 149.94 117.11 148.21 118.12 144.32 120.37 142.59 121.38 138.71 123.64 136.97 124.65 133.09 126.9 131.34 127.91 127.47 130.17 125.72 131.17 121.84 133.43 120.11 134.44 116.22 136.7 114.48 137.7 110.61 139.96 108.86 140.97 104.98 143.23 103.25 144.23 99.36 146.49 97.63 147.5 93.75 149.75 92 150.76 88.13 153.02 86.39 154.03 82.52 156.28 80.77 157.29 76.89 159.55 75.14 160.56 71.28 162.81 69.53 163.82 65.64 166.08 63.91 167.09 58.72 170.16 58.69 148.31 58.38 103.29 62.81 100.72 64.56 99.71 68.42 97.46 70.17 96.44 74.05 94.19 75.8 93.18 79.67 90.93 81.42 89.91 85.28 87.66 87.03 86.65 90.91 84.4 92.66 83.39 96.53 81.13 98.27 80.12 102.14 77.87 103.89 76.86 107.78 74.6 109.5 73.59 113.39 71.34 115.14 70.33 119.02 68.07 120.75 67.07 124.64 64.81 126.36 63.73 130.23 61.48 132 60.45 135.85 58.22 137.61 57.2 141.52 54.92 143.24 53.91 147.11 51.67 148.87 50.65 152.72 48.41 154.49 47.39 158.36 45.15 160.05 44.15 163.96 41.86 165.72 40.85 169.63 38.59 171.3 37.61 174.47 35.75 174.18 102.95"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.68 165.98 63.95 166.99 62.85 100.62 64.59 99.61 65.68 165.98"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.31 162.71 69.56 163.72 68.46 97.36 70.21 96.34 71.31 162.71"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "76.92 159.45 75.18 160.46 74.08 94.09 75.83 93.08 76.92 159.45"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.55 156.18 80.8 157.19 79.7 90.83 81.45 89.81 82.55 156.18"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.16 152.92 86.42 153.93 85.32 87.56 87.07 86.55 88.16 152.92"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "93.79 149.65 92.04 150.66 90.94 84.3 92.69 83.29 93.79 149.65"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.4 146.39 97.66 147.4 96.57 81.03 98.3 80.02 99.4 146.39"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.02 143.13 103.28 144.13 102.18 77.77 103.92 76.76 105.02 143.13"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "110.64 139.86 108.9 140.87 107.81 74.5 109.54 73.49 110.64 139.86"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.26 136.6 114.52 137.6 113.42 71.24 115.17 70.23 116.26 136.6"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "121.88 133.33 120.14 134.34 119.05 67.97 120.78 66.97 121.88 133.33"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "127.5 130.07 125.76 131.07 124.67 64.71 126.41 63.7 127.5 130.07"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.12 126.8 131.38 127.81 130.28 61.45 132.02 60.44 133.12 126.8"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.74 123.54 137 124.55 135.9 58.18 137.65 57.17 138.74 123.54"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.36 120.27 142.62 121.28 141.52 54.92 143.27 53.91 144.36 120.27"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "149.98 117.01 148.24 118.02 147.15 51.65 148.89 50.64 149.98 117.01"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "155.61 113.74 153.86 114.75 152.76 48.39 154.51 47.38 155.61 113.74"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "161.22 110.48 159.48 111.49 158.39 45.12 160.12 44.12 161.22 110.48"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "166.84 107.21 165.1 108.22 164 41.86 165.75 40.85 166.84 107.21"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.46 103.95 170.72 104.96 169.63 38.59 171.36 37.59 172.46 103.95"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M356.84,127.72a.65.65,0,0,1,0-.34c.1-.41.61-1.42,2.57-1.33,2.49.12,2.5,1.34,2.5,1.34s.31,1.39-2.4,1.69a2.49,2.49,0,0,1-.61,0C358.29,129,357.06,128.71,356.84,127.72Z",
    transform: "translate(-184.66 -96.63)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M308.7,100a.78.78,0,0,1,0-.34c.11-.41.61-1.42,2.58-1.33,2.48.12,2.56,1.35,2.56,1.35s.24,1.38-2.46,1.68a2.49,2.49,0,0,1-.61,0C310.15,101.24,308.93,101,308.7,100Z",
    transform: "translate(-184.66 -96.63)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M361.42,194.71s1.35-.9,1.85.59-1.39,4.09-2.73,3.89S359.07,196.45,361.42,194.71Z",
    transform: "translate(-184.66 -96.63)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M361.76,129.48a1.12,1.12,0,0,1,1.85.63c.5,1.61-1.39,4.42-2.74,4.2S359.4,131.36,361.76,129.48Z",
    transform: "translate(-184.66 -96.63)"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.07 144.46 49.16 173.29 49.16 174.08 0.07 145.5 0.07 144.46"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "53.26 104.69 53.26 104.78 53.02 135.07 52.97 141.49 52.7 176.02 52.58 175.95 0 145.41 0.17 73.27 1.68 74.45 53.26 104.69"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.67 158.81 26.39 158.64 26.22 158.54 26.03 158.44 25.55 158.16 24.89 157.78 24.72 157.67 13.71 151.28 13.53 151.17 12.86 150.79 12.7 150.68 12.2 150.4 12.03 150.3 11.37 149.92 11.2 149.82 2.07 144.51 2.04 132.13 2.04 131.83 11.18 137.14 11.35 137.25 12.01 137.63 12.5 137.91 12.68 138.02 12.85 138.11 13.51 138.5 14 138.78 24.7 145 24.88 145.1 25.53 145.48 25.66 145.56 25.71 145.59 26.01 145.76 26.2 145.88 26.37 145.97 26.64 146.13 26.64 146.44 26.67 158.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "27.4 145.25 26.42 144.98 1.82 130.68 2.8 130.95 27.4 145.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.61 133.25 25.63 134.65 1.49 120.61 2 118.95 26.61 133.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.66 145.86 1.52 131.83 1.49 120.61 25.63 134.65 25.66 145.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.61 133.25 2 118.95 1.95 100.28 26.55 114.57 26.61 133.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "27.31 113.69 26.33 113.43 1.73 99.13 2.71 99.39 27.31 113.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.52 101.7 25.54 103.09 1.66 89 1.91 87.4 26.52 101.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.57 114.31 1.69 100.21 1.66 89 25.54 103.09 25.57 114.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.52 101.7 1.91 87.4 1.88 76.99 26.49 91.29 26.52 101.7"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.33 173.15 39.68 166.39 39.2 166.1 38.55 165.72 38.37 165.62 38.18 165.51 37.71 165.23 37.05 164.85 36.88 164.75 27.52 159.31 27.05 159.04 26.73 158.86 26.73 158.78 26.69 146.47 26.69 146.17 27.03 146.37 27.4 146.58 27.51 146.65 36.86 152.08 37.03 152.18 37.69 152.57 38.17 152.85 38.36 152.95 38.53 153.05 39.19 153.43 39.66 153.71 50.32 159.9 51.29 160.47 51.33 173.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.26 147.59 50.28 148.99 25.68 134.69 26.65 133.3 51.26 147.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.32 160.2 25.71 145.91 25.68 134.69 50.28 148.99 50.32 160.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.6 114.62 51.21 128.92 51.26 147.59 26.65 133.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.17 116.04 50.2 117.44 25.59 103.14 26.56 101.74 51.17 116.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.23 128.65 25.62 114.35 25.59 103.14 50.2 117.44 50.23 128.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.17 116.04 26.56 101.74 26.53 91.33 51.14 105.63 51.17 116.04"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.86 150.79 12.7 150.68 12.69 138.32 12.68 138.02 12.68 136.69 12.67 127.11 12.67 125.15 12.65 106.8 12.65 105.17 12.63 95.59 12.63 93.63 12.62 83.3 12.8 83.68 12.81 93.74 12.81 95.69 12.82 105.26 12.82 106.9 12.84 125.25 12.85 127.21 12.85 136.79 12.85 137.1 12.85 138.42 12.86 150.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.76 83.13 13.93 83.51 13.45 83.79 12.79 83.69 12.62 83.3 13.1 83.03 13.76 83.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.53 151.17 12.86 150.79 12.85 138.42 12.85 137.1 12.85 136.79 12.85 127.21 12.84 125.25 12.82 106.9 12.82 105.26 12.81 95.69 12.81 93.74 12.8 83.68 13.45 83.78 13.46 94.12 13.46 96.08 13.48 105.65 13.48 107.28 13.5 125.64 13.5 127.59 13.51 137.17 13.51 138.5 13.52 138.8 13.53 151.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.01 151.1 13.71 151.28 13.53 151.17 13.52 138.8 13.51 138.5 13.51 137.17 13.5 127.59 13.5 125.64 13.48 107.28 13.48 105.65 13.46 96.08 13.46 94.12 13.45 83.78 13.51 83.75 13.94 83.5 13.94 84 13.94 94.4 13.95 96.36 13.96 105.93 13.96 107.57 13.98 125.92 13.98 127.87 13.99 137.45 13.99 137.76 14 138.78 14 139.08 14.01 151.1"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.37 149.92 11.2 149.82 11.19 137.45 11.18 137.14 11.18 135.82 11.17 126.24 11.17 124.28 11.15 105.93 11.15 104.3 11.13 94.72 11.13 92.76 11.12 82.42 11.3 82.81 11.31 92.86 11.31 94.83 11.33 104.4 11.33 106.03 11.35 124.39 11.35 126.34 11.35 135.92 11.35 137.55 11.37 149.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.26 82.25 12.44 82.63 11.96 82.91 11.3 82.81 11.13 82.43 11.61 82.15 12.26 82.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.03 150.3 11.37 149.92 11.35 137.55 11.35 135.92 11.35 126.34 11.35 124.39 11.33 106.03 11.33 104.4 11.31 94.83 11.31 92.86 11.3 82.81 11.95 82.91 11.96 93.24 11.96 95.21 11.98 104.78 11.98 106.41 12 124.76 12 126.72 12.01 136.3 12.01 137.63 12.02 137.93 12.03 150.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.51 150.23 12.2 150.4 12.03 150.3 12.02 137.93 12.01 137.63 12.01 136.3 12 126.72 12 124.76 11.98 106.41 11.98 104.78 11.96 95.21 11.96 93.24 11.95 82.91 12.01 82.88 12.44 82.63 12.44 83.13 12.44 93.52 12.45 95.49 12.46 105.06 12.46 106.69 12.48 125.04 12.48 127 12.49 136.59 12.49 136.89 12.5 137.91 12.5 138.22 12.51 150.23"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.55 165.72 38.37 165.62 38.36 153.26 38.36 151.93 38.35 151.63 38.34 142.06 38.34 140.09 38.32 121.74 38.32 120.1 38.31 110.53 38.31 108.57 38.3 98.6 38.47 98.98 38.48 108.67 38.48 110.63 38.5 120.2 38.5 121.83 38.52 140.19 38.52 142.15 38.53 151.73 38.53 153.36 38.55 165.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.44 98.43 39.61 98.81 39.13 99.09 38.47 98.98 38.3 98.61 38.78 98.33 39.44 98.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.2 166.1 38.55 165.72 38.53 153.36 38.53 151.73 38.52 142.15 38.52 140.19 38.5 121.83 38.5 120.2 38.48 110.63 38.48 108.67 38.47 98.98 39.13 99.09 39.14 109.06 39.14 111.01 39.15 120.58 39.15 122.22 39.17 140.57 39.17 142.53 39.18 152.11 39.19 152.42 39.19 153.74 39.2 166.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "39.68 166.39 39.2 166.1 39.19 153.74 39.19 152.42 39.18 152.11 39.17 142.53 39.17 140.57 39.15 122.22 39.15 120.58 39.14 111.01 39.14 109.06 39.13 99.09 39.5 98.87 39.61 98.81 39.61 98.94 39.62 109.33 39.62 111.29 39.64 120.86 39.64 122.5 39.66 140.85 39.66 142.81 39.66 152.39 39.66 153.71 39.67 154.02 39.68 166.39"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.05 164.85 36.88 164.75 36.86 152.39 36.86 150.76 36.85 141.19 36.85 139.22 36.83 120.86 36.83 119.23 36.81 109.66 36.81 107.7 36.8 97.72 36.97 98.11 36.98 107.8 36.98 109.76 37 119.33 37 120.97 37.02 139.31 37.02 141.28 37.03 150.85 37.03 152.48 37.05 164.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.94 97.55 38.12 97.93 37.63 98.21 36.98 98.11 36.8 97.73 37.28 97.45 37.94 97.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.71 165.23 37.05 164.85 37.03 152.48 37.03 150.85 37.02 141.28 37.02 139.31 37 120.97 37 119.33 36.98 109.76 36.98 107.8 36.97 98.11 37.63 98.21 37.64 108.18 37.64 110.15 37.66 119.72 37.66 121.35 37.68 139.71 37.68 141.66 37.69 151.24 37.69 152.86 37.71 165.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.18 165.51 37.71 165.23 37.69 152.86 37.69 151.24 37.68 141.66 37.68 139.71 37.66 121.35 37.66 119.72 37.64 110.15 37.64 108.18 37.63 98.21 38 98 38.12 97.93 38.12 98.07 38.13 108.46 38.13 110.43 38.14 120 38.14 121.63 38.16 139.99 38.16 141.94 38.17 151.51 38.17 153.14 38.18 165.51"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.45 158.81 26.27 158.71 26.26 146.34 26.26 145.02 26.25 144.71 26.24 135.14 26.24 133.17 26.22 114.83 26.22 113.19 26.21 103.61 26.21 101.66 26.2 91.69 26.37 92.07 26.38 101.75 26.38 103.72 26.4 113.29 26.4 114.92 26.42 133.28 26.42 135.23 26.43 144.81 26.43 146.44 26.45 158.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.34 91.51 27.51 91.89 27.03 92.17 26.37 92.07 26.2 91.69 26.68 91.41 27.34 91.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.1 159.18 26.45 158.81 26.43 146.44 26.43 144.81 26.42 135.23 26.42 133.28 26.4 114.92 26.4 113.29 26.38 103.72 26.38 101.75 26.37 92.07 27.04 92.17 27.04 102.14 27.04 104.1 27.05 113.67 27.05 115.3 27.07 133.66 27.07 135.62 27.08 145.19 27.09 145.5 27.09 146.83 27.1 159.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.58 159.47 27.1 159.18 27.09 146.83 27.09 145.5 27.08 145.19 27.07 135.62 27.07 133.66 27.05 115.3 27.05 113.67 27.04 104.1 27.04 102.14 27.04 92.17 27.4 91.96 27.51 91.89 27.51 92.02 27.52 102.41 27.52 104.38 27.54 113.95 27.54 115.58 27.56 133.94 27.56 135.9 27.57 145.47 27.57 146.8 27.57 147.11 27.58 159.47"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.95 157.93 24.78 157.84 24.76 145.47 24.76 143.84 24.75 134.27 24.75 132.31 24.73 113.95 24.73 112.32 24.71 102.75 24.71 100.78 24.7 90.81 24.87 91.19 24.88 100.89 24.88 102.84 24.9 112.42 24.9 114.05 24.92 132.4 24.92 134.37 24.93 143.94 24.93 145.57 24.95 157.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "25.84 90.64 26.02 91.02 25.53 91.3 24.88 91.19 24.7 90.81 25.19 90.53 25.84 90.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.61 158.32 24.95 157.93 24.93 145.57 24.93 143.94 24.92 134.37 24.92 132.4 24.9 114.05 24.9 112.42 24.88 102.84 24.88 100.89 24.87 91.19 25.53 91.3 25.54 101.27 25.54 103.23 25.56 112.8 25.56 114.43 25.58 132.79 25.58 134.75 25.59 144.33 25.59 145.95 25.61 158.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.08 158.6 25.61 158.32 25.59 145.95 25.59 144.33 25.58 134.75 25.58 132.79 25.56 114.43 25.56 112.8 25.54 103.23 25.54 101.27 25.53 91.3 25.9 91.08 26.02 91.02 26.02 91.16 26.03 101.55 26.03 103.51 26.04 113.08 26.04 114.71 26.06 133.07 26.07 135.03 26.07 144.6 26.07 146.23 26.08 158.6"
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "51.14 105.63 51.33 173.15 49.96 172.4 50.16 105.06 50.64 105.31"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.88 76.99 1.11 76.36 1 102.27 1.04 143.81 2.07 144.51 2.03 110.91 1.88 76.99"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.05 106.71 52.42 108.19 52.37 111.73 48.83 110.23 49.05 106.71"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.92 106.29 52.26 108.25 52.22 111.58 47.73 109.6 47.92 106.29"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "48.72 107.64 48.61 109.35 50.71 110.16 50.8 108.52 48.72 107.64"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.05 126.76 52.42 128.24 52.37 131.78 48.83 130.28 49.05 126.76"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.92 126.34 52.26 128.3 52.22 131.63 47.73 129.65 47.92 126.34"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "48.72 127.7 48.61 129.41 50.71 130.21 50.8 128.57 48.72 127.7"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "48.93 145.76 52.31 147.24 52.26 150.78 48.72 149.28 48.93 145.76"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.81 145.34 52.15 147.3 52.1 150.63 47.61 148.65 47.81 145.34"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "48.6 146.7 48.5 148.41 50.59 149.21 50.68 147.57 48.6 146.7"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "48.93 166.86 52.31 168.34 52.26 171.88 48.72 170.38 48.93 166.86"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.81 166.44 52.15 168.4 52.1 171.74 47.61 169.76 47.81 166.44"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "48.6 167.8 48.5 169.51 50.59 170.31 50.68 168.68 48.6 167.8"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "3.83 144.32 0.45 142.84 0.5 139.31 4.04 140.8 3.83 144.32"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.95 144.75 0.61 142.78 0.66 139.45 5.15 141.43 4.95 144.75"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.16 143.39 4.26 141.68 2.17 140.88 2.08 142.51 4.16 143.39"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "3.83 123.1 0.45 121.62 0.5 118.08 4.04 119.58 3.83 123.1"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.95 123.52 0.61 121.56 0.66 118.23 5.15 120.21 4.95 123.52"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.16 122.16 4.26 120.45 2.17 119.65 2.08 121.29 4.16 122.16"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "3.94 104.28 0.57 102.8 0.61 99.26 4.15 100.76 3.94 104.28"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.06 104.7 0.72 102.74 0.77 99.41 5.26 101.39 5.06 104.7"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.27 103.35 4.37 101.64 2.28 100.83 2.19 102.47 4.27 103.35"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "3.94 84.17 0.57 82.69 0.61 79.15 4.15 80.65 3.94 84.17"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.06 84.59 0.72 82.63 0.77 79.3 5.26 81.28 5.06 84.59"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "4.27 83.24 4.37 81.53 2.28 80.72 2.19 82.36 4.27 83.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOt);
export default __webpack_public_path__ + "static/media/OT.be07a8b7bea8dd295bc481bc952616ee.svg";
export { ForwardRef as ReactComponent };